import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 17.189 11.47 6.47a.75.75 0 0 1 1.06 0l10.72 10.719"
    }, null, -1)
  ]));
}
const arrowChevronUp = { render };
export {
  arrowChevronUp as default,
  render
};
//# sourceMappingURL=arrow-chevron-up.svg.js.map
